import { render, staticRenderFns } from "./smart_insertion.vue?vue&type=template&id=e2ce95ba&scoped=true"
import script from "./smart_insertion.vue?vue&type=script&lang=js"
export * from "./smart_insertion.vue?vue&type=script&lang=js"
import style0 from "./smart_insertion.vue?vue&type=style&index=0&id=e2ce95ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ce95ba",
  null
  
)

export default component.exports